/**
 * Soar · Creatine-bar PDP controller (template product.creatine-bar).
 * Buy box (per-box pricing, 1/3 box, flavor mix slider, subscribe checkbox), sticky ATC,
 * science tabs, UGC rail, review "show more", scroll reveal. Self-contained; no deps.
 */
(function () {
  'use strict';
  if (window.__scbWired) return;
  window.__scbWired = true;
  document.documentElement.classList.add('scb-js');

  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var money = function (cents) { return '$' + (Math.round(cents) / 100).toFixed(2); };
  // Per-box prices floor to the cent ($121.49 / 3 = $40.496 → $40.49), matching the old buy box.
  var moneyFloor = function (cents) { return '$' + (Math.floor(cents + 1e-6) / 100).toFixed(2); };

  // ─────────────────────────── Cart ───────────────────────────
  function xhr(method, url, data, cb) {
    var x = new XMLHttpRequest();
    x.open(method, url, true);
    x.setRequestHeader('Content-Type', 'application/json');
    x.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    x.onload = function () { var r = {}; try { r = JSON.parse(x.responseText); } catch (e) {} cb(r, x.status); };
    x.onerror = function () { cb({}, 0); };
    x.send(data ? JSON.stringify(data) : null);
  }
  var toastEl, toastT;
  function toast(msg) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'scb-toast'; toastEl.setAttribute('role', 'status'); document.body.appendChild(toastEl); }
    toastEl.textContent = msg; toastEl.classList.add('is-on');
    clearTimeout(toastT); toastT = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2400);
  }
  function cartAdd(items, btns) {
    var body = { items: items };
    var drawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; }).join(',');
      body.sections_url = window.location.pathname;
    }
    btns.forEach(function (b) { b.disabled = true; b.setAttribute('aria-busy', 'true'); });
    xhr('POST', '/cart/add.js', body, function (res, status) {
      btns.forEach(function (b) { b.disabled = false; b.removeAttribute('aria-busy'); });
      if (status !== 200 || (res && res.status && res.status !== 200)) { toast((res && (res.description || res.message)) || 'Could not add to cart'); return; }
      if (drawer) {
        drawer.classList.remove('is-empty');
        try { if (typeof drawer.renderContents === 'function') drawer.renderContents(res); else if (drawer.open) drawer.open(); }
        catch (e) { if (drawer.open) drawer.open(); }
        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) { try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'scb' }); } catch (e) {} }
        toast('Added to cart');
      } else {
        window.location.href = '/cart';
      }
    });
  }

  // ─────────────────────────── Buy box ───────────────────────────
  // One offer: 3 boxes (30 bars). Mix stops: 30/0, 20/10, 10/20, 0/30 (Fudge / PB).
  // Hardened: every control is wired with delegated listeners (survives theme-editor re-renders
  // and apps that re-draw the DOM), a broken/missing Liquid config falls back to the live
  // /products/<handle>.js data, and nothing throws if a variant or plan is missing.
  var SUB_APP = '5859381';
  function parseCfg(box) {
    var el = $('[data-scb-config]', box.closest('.scb') || document) || $('[data-scb-config]');
    var cfg = null;
    if (el) { try { cfg = JSON.parse(el.textContent); } catch (e) { cfg = null; } }
    cfg = cfg || {};
    var d = box.dataset || {};
    cfg.variants = cfg.variants || {};
    cfg.labels = cfg.labels || { f: d.labelF || 'Fudge Brownie', p: d.labelP || 'Peanut Butter Choc Chip' };
    cfg.sugar = cfg.sugar || { f: '1G', p: '2G' };
    cfg.handles = cfg.handles || { f: d.handleF || 'fudgebrownie', p: d.handleP || 'the-creatine-protein-bar-pbcc' };
    cfg.display = cfg.display || {};
    ['one', 'sub', 'anchor'].forEach(function (k) { var v = d['display' + k.charAt(0).toUpperCase() + k.slice(1)]; if (v && !cfg.display[k]) cfg.display[k] = +v; });
    if (cfg.subMobile == null) cfg.subMobile = d.subMobile !== 'false';
    if (cfg.subDesktop == null) cfg.subDesktop = d.subDesktop === 'true';
    return cfg;
  }
  // Build our variant shape from a /products/<handle>.js payload.
  function fromProductJs(pj) {
    var groups = (pj.selling_plan_groups || []);
    var appGroups = groups.filter(function (g) { return String(g.app_id) === SUB_APP; });
    if (!appGroups.length) appGroups = groups;
    var planNames = {};
    appGroups.forEach(function (g) { (g.selling_plans || []).forEach(function (sp) { planNames[sp.id] = sp.name; }); });
    var out = { v10: null, v30: null };
    (pj.variants || []).forEach(function (v) {
      var allocs = (v.selling_plan_allocations || []).filter(function (a) { return planNames[a.selling_plan_id] != null; });
      var best = Infinity; allocs.forEach(function (a) { if (a.price < best) best = a.price; });
      var plans = allocs.filter(function (a) { return a.price === best; }).map(function (a) { return { id: a.selling_plan_id, name: planNames[a.selling_plan_id], price: a.price }; });
      var o = { id: v.id, price: v.price, compare: v.compare_at_price || 0, available: v.available !== false, title: v.title, plans: plans };
      var t = String(v.title || '').toLowerCase();
      if (t.indexOf('30') > -1) out.v30 = o; else if (t.indexOf('10') > -1) out.v10 = o;
    });
    if (!out.v10 && pj.variants && pj.variants[0]) out.v10 = null;
    return out;
  }
  function getJSON(url, cb) {
    var x = new XMLHttpRequest(); x.open('GET', url, true);
    x.onload = function () { var r = null; try { r = JSON.parse(x.responseText); } catch (e) {} cb(x.status === 200 ? r : null); };
    x.onerror = function () { cb(null); }; x.send();
  }

  function Buy(box) {
    var cfg = parseCfg(box);
    if (cfg.builder === 'cards') return BuyCards(box, cfg);
    var V = cfg.variants;
    var BOXES = 3;
    var S = { mix: 0, sub: false, f: 0, p: 0 };
    var mq = window.matchMedia ? window.matchMedia('(max-width: 749px)') : { matches: false };
    var wantSub = mq.matches ? !!cfg.subMobile : !!cfg.subDesktop;
    var MIX = [];

    function line(v, q, props) { return v ? { v: v, q: q, props: props || null } : null; }
    function clean(arr) { if (!arr) return null; var a = arr.filter(Boolean); return a.length ? a : null; }
    function mixLabel(f, p) { return f + ' ' + cfg.labels.f + ' + ' + p + ' ' + cfg.labels.p; }
    function mixFallback(f, p) {
      if ((cfg.mixMode || 'property') === 'property') {
        var base = (f >= p ? V.f30 : V.p30) || V.f30 || V.p30;
        return base ? [line(base, 1, { 'Flavor mix': mixLabel(f, p) })] : null;
      }
      return clean([line(V.f10, f / 10), line(V.p10, p / 10)]);
    }
    function pick(primary, fallback) { return primary ? [line(primary, 1)] : clean(fallback); }
    function build() {
      MIX = [
        { f: 30, p: 0, lines: pick(V.f30, V.f10 ? [line(V.f10, 3)] : null) },
        { f: 20, p: 10, lines: pick(V.vf, mixFallback(20, 10)) },
        { f: 10, p: 20, lines: pick(V.vp, mixFallback(10, 20)) },
        { f: 0, p: 30, lines: pick(V.p30, V.p10 ? [line(V.p10, 3)] : null) }
      ];
    }
    build();

    function lines(o) { return (o && o.lines) || []; }
    function onetime(o) { return lines(o).reduce(function (s, l) { return s + l.v.price * l.q; }, 0); }
    function planFor(v) {
      var ps = (v && v.plans) || []; if (!ps.length) return null;
      if (cfg.planId) for (var j = 0; j < ps.length; j++) if (String(ps[j].id) === String(cfg.planId)) return ps[j];
      for (var m = 0; m < ps.length; m++) if (/month/i.test(ps[m].name || '')) return ps[m];
      for (var i = 0; i < ps.length; i++) if (/\b4\s*week/i.test(ps[i].name || '')) return ps[i];
      return ps[0];
    }
    function canSub(o) { var L = lines(o); return L.length > 0 && L.every(function (l) { return !!planFor(l.v); }); }
    function subtotal(o) { return lines(o).reduce(function (s, l) { var p = planFor(l.v); return s + (p ? p.price : l.v.price) * l.q; }, 0); }
    function available(o) { var L = lines(o); return L.length > 0 && L.every(function (l) { return l.v.available !== false; }); }

    try {
      var q = new URLSearchParams(window.location.search).get('flavor');
      if (((q && /pb|peanut/i.test(q)) || cfg.startPB)) S.mix = 3;
    } catch (e) {}

    var els = {
      mix: $('[data-scb-mix]', box),
      range: $('[data-scb-range]', box), rail: $('[data-scb-rail]', box), ends: $$('[data-scb-end]', box),
      summary: $('[data-scb-mix-summary]', box),
      bdF: $('[data-scb-bd="f"]', box), bdP: $('[data-scb-bd="p"]', box),
      cardPer: $('[data-scb-card-per]', box), cardStrike: $('[data-scb-card-strike]', box), cardSave: $('[data-scb-card-save]', box),
      sub: $('[data-scb-sub]', box), subBtn: $('[data-scb-sub-toggle]', box),
      subSub: $('[data-scb-sub-sub]', box), subPrice: $('[data-scb-sub-price]', box), subStrike: $('[data-scb-sub-strike]', box), subPer: $('[data-scb-sub-per]', box),
      add: $('[data-scb-add]', box), addPrice: $('[data-scb-add-price]', box), addLabel: $('[data-scb-add-label]', box)
    };
    function refresh() { // re-query in case the DOM was re-drawn
      Object.keys(els).forEach(function (k) {
        if (k === 'ends') { els.ends = $$('[data-scb-end]', box); return; }
      });
    }

    var pick = $('[data-om-pick]', box);
    function complete() { return !pick || S.f + S.p === BOXES; }
    function pickStep(k, d) {
      var other = k === 'f' ? S.p : S.f;
      S[k] = Math.max(0, Math.min(BOXES - other, S[k] + d));
      if (S.f + S.p === BOXES) S.mix = S.p;
      var need = $('[data-om-need]', box); if (need && complete()) need.hidden = true;
      render();
    }
    // Box mode: map the chosen box mix to variants.
    //  - mixMode 'variety': ONE clean line item — 3 boxes of a flavor = that flavor's 30-pack;
    //    2+1 / 1+2 = the matching Variety-Pack SKU (VARIETY-2FB1PB / VARIETY-2PB1FB).
    //  - otherwise: each flavor's 10-pack × number of boxes (legacy split carts).
    function current() {
      if (cfg.boxMode && pick) {
        var done = S.f + S.p === BOXES;
        if ((cfg.mixMode || '') === 'variety') {
          // f30 / p30 / vfpVar (2 fudge + 1 pb) / vpfVar (1 fudge + 2 pb). f30 as a price stand-in until complete.
          var v = done ? (S.f === 3 ? V.f30 : (S.p === 3 ? V.p30 : (S.f === 2 ? V.vfpVar : V.vpfVar))) : V.f30;
          if (v) return { f: S.f * 10, p: S.p * 10, lines: [line(v, 1)] };
        } else if (V.f10 && V.p10) {
          var L = done ? [line(V.f10, S.f), line(V.p10, S.p)].filter(function (l) { return l && l.q > 0; }) : [line(V.f10, BOXES)];
          return { f: S.f * 10, p: S.p * 10, lines: L };
        }
      }
      return MIX[S.mix];
    }
    function describe(o) {
      var L = cfg.labels;
      if (!o.p) return o.f + ' ' + L.f;
      if (!o.f) return o.p + ' ' + L.p;
      return o.f + ' ' + L.f + ' + ' + o.p + ' ' + L.p;
    }
    function pctOff(perBox, anchor) { return anchor ? Math.round((1 - perBox / anchor) * 100) : 0; }
    function txt(el, t) { if (el) el.textContent = t; }

    function render() {
      var o = current() || MIX[0];
      var hasLines = !!(o && o.lines);
      var subOK = hasLines ? canSub(o) : !!cfg.display.sub;
      // Show the toggle state the shopper picked; only attach a plan when one exists.
      S.sub = wantSub && (subOK || !!cfg.display.sub);
      var ot = hasLines ? onetime(o) : 0, sp = hasLines && canSub(o) ? subtotal(o) : ot;
      var otPer = Math.floor(ot / BOXES + 1e-6), spPer = Math.floor(sp / BOXES + 1e-6);
      if (cfg.display.one) otPer = cfg.display.one;
      if (cfg.display.sub) spPer = cfg.display.sub;
      var per = S.sub ? spPer : otPer;
      var anchor = cfg.display.anchor || cfg.baseline || 0;
      var pct = pctOff(per, anchor);

      txt(els.cardPer, money(per));
      if (els.cardStrike) { els.cardStrike.hidden = !(pct >= 1); els.cardStrike.textContent = money(anchor); }
      if (els.cardSave) { els.cardSave.hidden = !(pct >= 1); els.cardSave.textContent = 'Save ' + pct + '%'; }

      if (els.range && +els.range.value !== S.mix) els.range.value = S.mix;
      if (els.range && o) els.range.setAttribute('aria-valuetext', o.f + ' ' + cfg.labels.f + ', ' + o.p + ' ' + cfg.labels.p);
      if (els.rail) els.rail.style.setProperty('--fill', (100 - S.mix / 3 * 100) + '%');
      if (els.mix) els.mix.style.setProperty('--pos', (S.mix / 3 * 100) + '%');
      els.ends.forEach(function (e) { var k = e.getAttribute('data-scb-end'); e.classList.toggle('is-lead', k === 'f' ? o.f >= o.p : o.p > o.f); });
      function bd(el, n) {
        if (!el) return;
        txt($('[data-scb-bd-n]', el), n);
        var b = n / 10;
        txt($('[data-scb-bd-boxes]', el), b + (b === 1 ? ' box' : ' boxes'));
        el.classList.toggle('is-zero', n === 0);
      }
      bd(els.bdF, o.f); bd(els.bdP, o.p);
      txt(els.summary, describe(o));
      $$('[data-scb-flavorname]').forEach(function (el) { if (pick && !complete()) { el.textContent = S.f + S.p === 0 ? cfg.labels.f : (S.f + ' Fudge + ' + S.p + ' PB so far'); return; } el.textContent = o.f && o.p ? (o.f + ' Fudge + ' + o.p + ' PB') : (o.p ? cfg.labels.p : cfg.labels.f); });
      $$('[data-scb-sugar]').forEach(function (el) { el.textContent = o.p > o.f ? cfg.sugar.p : cfg.sugar.f; });
      var lead = pick && !complete() ? ((S.p > S.f || (S.f + S.p === 0 && cfg.startPB)) ? 'pb' : 'fudge') : (o.p > o.f ? 'pb' : 'fudge');
      var gals = $$('[data-scb-gallery]');
      if (gals.some(function (g) { return g.getAttribute('data-scb-gallery') === lead; })) gals.forEach(function (g) { g.hidden = g.getAttribute('data-scb-gallery') !== lead; });
      try { buildDots(); } catch (e) {}

      if (els.subBtn) {
        if (els.sub) els.sub.classList.toggle('is-on', S.sub);
        els.subBtn.classList.toggle('is-on', S.sub);
        els.subBtn.setAttribute('aria-checked', S.sub ? 'true' : 'false');
        if (els.subPrice) els.subPrice.hidden = false;
        if (els.subStrike) { els.subStrike.textContent = money(otPer); els.subStrike.hidden = !(otPer > spPer); }
        txt(els.subPer, money(spPer));
        if (els.subSub) els.subSub.hidden = true;
      }

      // Stacked flavor picker (add / − / +)
      if (pick) {
        var tot = S.f + S.p, done = tot === BOXES;
        ['f', 'p'].forEach(function (k) {
          var n = S[k];
          var ad = $('[data-om-pick-add="' + k + '"]', box), q = $('[data-om-pick-qty="' + k + '"]', box);
          if (ad) { ad.hidden = n > 0; ad.disabled = done; }
          if (q) q.hidden = n === 0;
          txt($('[data-om-pick-n="' + k + '"]', box), n);
          var sub = $('[data-om-pick-sub="' + k + '"]', box);
          if (sub) sub.textContent = n ? (n * 10) + ' bars · ' + n + (n === 1 ? ' box' : ' boxes') : '1 box = 10 bars';
          $$('[data-om-pick-step="' + k + '"]', box).forEach(function (b) { b.disabled = +b.getAttribute('data-d') > 0 ? done : n === 0; });
          var row = $('[data-om-pick-row="' + k + '"]', box); if (row) row.classList.toggle('is-on', n > 0);
        });
        txt($('[data-om-pick-total]', box), tot);
        var fill = $('[data-om-pick-fill]', box); if (fill) fill.style.width = (tot > 0 ? (tot - 1) / (BOXES - 1) * 100 : 0) + '%';
        var foot = $('[data-om-pick-foot]', box); if (foot) foot.classList.toggle('is-done', done);
        var msg = $('[data-om-pick-msg]', box);
        if (msg) msg.textContent = done ? '✓ Your 30-pack is complete · ' + describe(o) : (tot === 0 ? 'Add 3 boxes (30 bars) — mix flavors any way you like' : 'Add ' + (BOXES - tot) * 10 + ' more bars to complete your 30-pack');
        pick.classList.toggle('is-done', done);
        $$('[data-om-cp]', box).forEach(function (c) { c.classList.toggle('is-on', tot >= +c.getAttribute('data-om-cp')); });
      }
      if (els.add) { els.add.classList.toggle('is-locked', !complete()); }
      if (pick && !complete()) {
        var lft = (BOXES - S.f - S.p) * 10;
        txt(els.addLabel, S.f + S.p === 0 ? 'Select 30 bars' : 'Add ' + lft + ' more bars');
        $$('[data-om-addprice]', box).forEach(function (e) { e.hidden = true; });
      } else { $$('[data-om-addprice]', box).forEach(function (e) { e.hidden = false; }); }
      $$('[data-om-suboff]', box).forEach(function (e) { var d = Math.max(0, otPer - spPer); e.textContent = '$' + (d % 100 ? (d / 100).toFixed(2) : (d / 100)) + ' off'; });
      box.classList.toggle('is-onetime', !S.sub);
      // Omni buy box hooks
      $$('[data-scb-mixset]', box).forEach(function (b) { var on = +b.getAttribute('data-scb-mixset') === S.mix; b.classList.toggle('is-on', on); b.setAttribute('aria-checked', on ? 'true' : 'false'); });
      var mixOn = S.mix === 1 || S.mix === 2;
      $$('[data-om-mix]', box).forEach(function (b) { b.classList.toggle('is-on', mixOn); b.setAttribute('aria-checked', mixOn ? 'true' : 'false'); });
      $$('[data-om-mixrow]', box).forEach(function (r) { r.classList.toggle('is-open', mixOn || r.__forceOpen === true); });
      $$('[data-scb-plan]', box).forEach(function (b) { var on = (b.getAttribute('data-scb-plan') === 'sub') === S.sub; b.classList.toggle('is-on', on); b.setAttribute('aria-checked', on ? 'true' : 'false'); });
      $$('[data-om-price="sub"]', box).forEach(function (e) { e.textContent = money(spPer); });
      $$('[data-om-price="one"]', box).forEach(function (e) { e.textContent = money(otPer); });
      $$('[data-om-bar="sub"]', box).forEach(function (e) { e.textContent = money(Math.floor(spPer / 10)); });
      $$('[data-om-bar="one"]', box).forEach(function (e) { e.textContent = money(Math.floor(otPer / 10)); });
      $$('[data-om-subcard-price]', box).forEach(function (e) { e.textContent = money(S.sub ? spPer : otPer); });
      $$('[data-om-subcard-strike]', box).forEach(function (e) {
        if (cfg.promoAnchor && anchor) { var cur = S.sub ? spPer : otPer; e.textContent = money(anchor); e.hidden = !(anchor > cur); }
        else { e.textContent = money(otPer); e.hidden = !S.sub || !(otPer > spPer); }
      });
      $$('[data-om-strike-one]', box).forEach(function (e) { e.textContent = money(otPer); e.hidden = !(otPer > spPer); });
      $$('[data-om-strike]', box).forEach(function (e) { e.textContent = money(anchor); e.hidden = !anchor; });
      $$('[data-om-off="sub"]', box).forEach(function (e) { var p = pctOff(spPer, anchor); e.textContent = 'Save ' + p + '%'; e.hidden = p < 1; });
      $$('[data-om-off="one"]', box).forEach(function (e) { var p = pctOff(otPer, anchor); e.textContent = p + '% OFF'; e.hidden = p < 1; });
      $$('[data-om-subonly]', box).forEach(function (e) { e.hidden = !S.sub; });
      $$('[data-om-oneonly]', box).forEach(function (e) { e.hidden = S.sub; });
      txt(els.addPrice, money(per));
      var avail = hasLines ? available(o) : false;
      if (els.add) { els.add.disabled = !avail; els.add.setAttribute('aria-disabled', avail ? 'false' : 'true'); }
      if (!(pick && !complete())) txt(els.addLabel, hasLines && !avail ? 'Sold Out' : 'Add to Cart');
      box.setAttribute('data-scb-ready', hasLines ? 'true' : 'loading');
      document.dispatchEvent(new CustomEvent('scb:change', { detail: { perBox: per, sub: S.sub, desc: '3 Boxes · ' + describe(o), avail: avail } }));
    }

    function items() {
      return lines(current()).map(function (l) {
        var it = { id: l.v.id, quantity: l.q };
        if (l.props) it.properties = l.props;
        if (S.sub) { var p = planFor(l.v); if (p) it.selling_plan = p.id; }
        return it;
      });
    }

    function setMix(v) {
      v = Math.max(0, Math.min(3, Math.round(+v || 0)));
      S.mix = v; render();
    }
    function toggleSub() { wantSub = !S.sub; render(); }
    function toggleMix(btn) {
      if (!els.mix) return;
      var open = !els.mix.classList.contains('is-open');
      els.mix.classList.toggle('is-open', open); btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    function add(extraBtns) {
      if (!complete()) {
        var left = BOXES - S.f - S.p, need = $('[data-om-need]', box);
        if (need) { need.textContent = left === BOXES ? 'Build your 30-pack first — add 30 bars above to continue.' : 'Almost there! Add ' + left * 10 + ' more bars to complete your 30-pack.'; need.hidden = false; }
        if (pick) { pick.classList.add('is-open', 'om-shake'); setTimeout(function () { pick.classList.remove('om-shake'); }, 500); if (pick.getBoundingClientRect().top < 0) pick.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
        return;
      }
      var its = items();
      if (!its.length) { toast('Loading prices — try again in a second'); return; }
      cartAdd(its, [els.add].concat(extraBtns || []).filter(Boolean));
    }

    // Live product data: fills anything the Liquid config couldn't (missing plans, missing PB product).
    function needsLive() {
      if (!V.f30 || !V.p30) return true;
      return !(planFor(V.f30) && planFor(V.p30));
    }
    function loadLive() {
      var pending = 2, got = {};
      function done() {
        if (--pending) return;
        if (got.f) { if (!V.f30 || !planFor(V.f30)) V.f30 = got.f.v30 || V.f30; if (!V.f10) V.f10 = got.f.v10; }
        if (got.p) { if (!V.p30 || !planFor(V.p30)) V.p30 = got.p.v30 || V.p30; if (!V.p10) V.p10 = got.p.v10; }
        build(); render();
      }
      getJSON('/products/' + cfg.handles.f + '.js', function (r) { if (r) got.f = fromProductJs(r); done(); });
      getJSON('/products/' + cfg.handles.p + '.js', function (r) { if (r) got.p = fromProductJs(r); done(); });
    }
    if (needsLive()) loadLive();

    function buildDots() {
      var dots = $('[data-scb-dots]');
      var g = $$('[data-scb-gallery]').filter(function (x) { return !x.hidden; })[0];
      if (!dots || !g) return;
      var slides = $$('.scb-gal__item, .scb-gal__macros', g);
      if (dots.getAttribute('data-for') === g.getAttribute('data-scb-gallery') && dots.children.length === slides.length) return;
      dots.setAttribute('data-for', g.getAttribute('data-scb-gallery'));
      dots.innerHTML = slides.length > 1 ? slides.map(function (_, i) { return '<span' + (i === 0 ? ' class="is-on"' : '') + '></span>'; }).join('') : '';
      if (!g.__scbDots) {
        g.__scbDots = true;
        g.addEventListener('scroll', function () {
          var ss = $$('.scb-gal__item, .scb-gal__macros', g);
          var mid = g.scrollLeft + g.clientWidth / 2, idx = 0, best = 1e9;
          ss.forEach(function (sl, i) { var c = sl.offsetLeft + sl.offsetWidth / 2; var d = Math.abs(c - mid); if (d < best) { best = d; idx = i; } });
          $$('span', dots).forEach(function (d, i) { d.classList.toggle('is-on', i === idx); });
        }, { passive: true });
      }
    }

    function setSub(on) { wantSub = !!on; render(); }
    return { add: add, el: els.add, render: render, pickStep: pickStep, setMix: setMix, toggleSub: toggleSub, setSub: setSub, toggleMix: toggleMix, box: box, mix: function () { return S.mix; } };
  }

  // ─────────────────────────── Buy box (cards) ───────────────────────────
  // Card picker: flavor (Fudge / PBCC / Variety) → size (30/10) or variety pack mix → subscribe.
  // Same no-new-SKU cart model: N × the 10-bar box variant in one /cart/add.js, plan attached per
  // line when subscribed. Per-box display prices come from the Liquid config (cfg.prices), so the
  // same box variant can read $44.99 at 1 box and $39.99 at 3 (a cart discount matches it at checkout).
  function BuyCards(box, cfg) {
    var V = cfg.variants || {};
    var PR = cfg.prices || { p30: { one: 3999, sub: 2999 }, p10: { one: 4499, sub: 3499 } };
    var LBL = cfg.labels || { f: 'Fudge Brownie', p: 'Peanut Butter Choc Chip' };
    var VARIETY = cfg.varietyLabel || 'Variety Pack';
    var PSHORT = 'PBCC';
    var S = { flavor: 'f', size: 30, pack: 'vpf', sub: false, f: 0, p: 0 };
    var mq = window.matchMedia ? window.matchMedia('(max-width: 749px)') : { matches: false };
    var wantSub = mq.matches ? !!cfg.subMobile : !!cfg.subDesktop;
    try { var qf = new URLSearchParams(window.location.search).get('flavor'); if ((qf && /pb|peanut/i.test(qf)) || cfg.startPB) S.flavor = 'p'; } catch (e) {}

    // Always attach the MONTHLY plan: the shared Soar monthly plan by id (10-pack + variety),
    // else any plan named "…month" (the 30-pack's monthly), else a 4-week equivalent, else first.
    function planFor(v) {
      var ps = (v && v.plans) || []; if (!ps.length) return null;
      if (cfg.planId) for (var j = 0; j < ps.length; j++) if (String(ps[j].id) === String(cfg.planId)) return ps[j];
      for (var m = 0; m < ps.length; m++) if (/month/i.test(ps[m].name || '')) return ps[m];
      for (var i = 0; i < ps.length; i++) if (/\b4\s*weeks?\b/i.test(ps[i].name || '')) return ps[i];
      return ps[0];
    }
    function big() { return S.flavor === 'v' || S.size === 30; }
    function boxes() { return S.flavor === 'v' ? 3 : (S.size === 10 ? 1 : 3); }
    function tier() { return big() ? PR.p30 : PR.p10; }
    function perBoxOne() { return tier().one; }
    function perBoxSub() { return tier().sub; }
    function perBox() { return S.sub ? perBoxSub() : perBoxOne(); }
    function total() { return perBox() * boxes(); }
    function lineDefs() {
      // Single flavor → the flavor product's own 10-pack or 30-pack variant (one line item).
      if (S.flavor === 'f') return [[S.size === 10 ? V.f10 : V.f30, 1]];
      if (S.flavor === 'p') return [[S.size === 10 ? V.p10 : V.p30, 1]];
      // Variety → build-your-30: 3F=f30, 3P=p30, 2F+1P=vfpVar, 1F+2P=vpfVar. ONE clean line.
      if (S.f + S.p !== 3) return [];
      var vv = S.f === 3 ? V.f30 : (S.p === 3 ? V.p30 : (S.f === 2 ? V.vfpVar : V.vpfVar));
      return vv ? [[vv, 1]] : [];
    }
    function canSub() { var L = lineDefs(); return L.length > 0 && L.every(function (d) { return d[0] && planFor(d[0]); }); }
    function available() { var L = lineDefs(); return L.length > 0 && L.every(function (d) { return d[0] && d[0].available !== false; }); }
    function items() {
      return lineDefs().filter(function (d) { return d[0]; }).map(function (d) {
        var it = { id: d[0].id, quantity: d[1] };
        if (S.sub) { var pl = planFor(d[0]); if (pl) it.selling_plan = pl.id; }
        return it;
      });
    }

    var els = {
      flavorSel: $('[data-scb-flavor-sel]', box), sizeSel: $('[data-scb-size-sel]', box), packSel: $('[data-scb-pack-sel]', box),
      sizeGroup: $('[data-scb-size-group]', box), packGroup: $('[data-scb-pack-group]', box),
      sub: $('[data-scb-sub]', box), subBtn: $('[data-scb-sub-toggle]', box),
      add: $('[data-scb-add]', box), addPrice: $('[data-scb-add-price]', box), addLabel: $('[data-scb-add-label]', box), addWrap: $('[data-om-addprice]', box)
    };
    function txt(el, t) { if (el) el.textContent = t; }
    function flavorName() { return S.flavor === 'v' ? VARIETY : (S.flavor === 'p' ? LBL.p : LBL.f); }

    function setFlavor(k) { if (k === 'f' || k === 'p' || k === 'v') { S.flavor = k; render(); } }
    function setSize(n) { S.size = (+n === 10 ? 10 : 30); render(); }
    function setPack(k) { if (k === 'vpf' || k === 'vfp') { S.pack = k; render(); } }
    function toggleSub() { wantSub = !S.sub; render(); }
    function setSub(on) { wantSub = !!on; render(); }
    // Variety build-your-30 stepper (box counts for Fudge / PB).
    function vComplete() { return S.f + S.p === 3; }
    function pickStep(k, d) {
      if (k !== 'f' && k !== 'p') return;
      var other = k === 'f' ? S.p : S.f;
      S[k] = Math.max(0, Math.min(3 - other, S[k] + d));
      render();
    }

    function render() {
      S.sub = wantSub && canSub();
      var variety = S.flavor === 'v';
      if (els.sizeGroup) els.sizeGroup.hidden = variety;
      if (els.packGroup) els.packGroup.hidden = !variety;
      $$('[data-scb-flavor]', box).forEach(function (b) { var on = b.getAttribute('data-scb-flavor') === S.flavor; b.classList.toggle('is-on', on); b.setAttribute('aria-checked', on ? 'true' : 'false'); });
      $$('[data-scb-size]', box).forEach(function (b) { var on = +b.getAttribute('data-scb-size') === S.size; b.classList.toggle('is-on', on); b.setAttribute('aria-checked', on ? 'true' : 'false'); });
      $$('[data-scb-pack]', box).forEach(function (b) { var on = b.getAttribute('data-scb-pack') === S.pack; b.classList.toggle('is-on', on); b.setAttribute('aria-checked', on ? 'true' : 'false'); });
      txt(els.flavorSel, flavorName());
      txt(els.sizeSel, S.size === 10 ? '10 Pack' : '30 Pack');
      txt(els.packSel, S.pack === 'vpf' ? 'Mostly PB Choc Chip' : 'Mostly Fudge Brownie');
      $$('[data-scb-flavorname]').forEach(function (el) { el.textContent = flavorName(); });
      var mode = S.sub ? 'sub' : 'one';
      // Single-size cards show per box; only the Variety cards show the full pack total (+ per box under it).
      $$('[data-scb-price-30]', box).forEach(function (e) { e.textContent = money(PR.p30[mode]) + '/box'; });
      $$('[data-scb-price-10]', box).forEach(function (e) { e.textContent = money(PR.p10[mode]) + '/box'; });
      $$('[data-scb-price-vpf]', box).forEach(function (e) { e.textContent = money(PR.p30[mode] * 3); });
      $$('[data-scb-price-vfp]', box).forEach(function (e) { e.textContent = money(PR.p30[mode] * 3); });
      $$('[data-scb-pb-vpf]', box).forEach(function (e) { e.textContent = money(PR.p30[mode]) + '/box'; });
      $$('[data-scb-pb-vfp]', box).forEach(function (e) { e.textContent = money(PR.p30[mode]) + '/box'; });
      $$('[data-scb-barcount]').forEach(function (e) { e.textContent = boxes() * 10; });
      // Variety build-your-30 stepper UI
      if (variety) {
        var vtot = S.f + S.p, vdone = vtot === 3;
        ['f', 'p'].forEach(function (k) {
          var n = S[k];
          var ad = $('[data-om-pick-add="' + k + '"]', box), q = $('[data-om-pick-qty="' + k + '"]', box);
          if (ad) { ad.hidden = n > 0; ad.disabled = vdone; }
          if (q) q.hidden = n === 0;
          txt($('[data-om-pick-n="' + k + '"]', box), n);
          $$('[data-om-pick-step="' + k + '"]', box).forEach(function (b) { b.disabled = +b.getAttribute('data-d') > 0 ? vdone : n === 0; });
          var row = $('[data-om-pick-row="' + k + '"]', box); if (row) row.classList.toggle('is-on', n > 0);
        });
        var vfill = $('[data-om-pick-fill]', box); if (vfill) vfill.style.width = (vtot > 0 ? (vtot - 1) / 2 * 100 : 0) + '%';
        $$('[data-om-cp]', box).forEach(function (c) { c.classList.toggle('is-on', vtot >= +c.getAttribute('data-om-cp')); });
      }
      var lead = S.flavor === 'p' ? 'pb' : 'fudge';
      var gals = $$('[data-scb-gallery]');
      if (gals.some(function (g) { return g.getAttribute('data-scb-gallery') === lead; })) gals.forEach(function (g) { g.hidden = g.getAttribute('data-scb-gallery') !== lead; });
      var one = perBoxOne(), sub = perBoxSub();
      if (els.subBtn) {
        if (els.sub) els.sub.classList.toggle('is-on', S.sub);
        els.subBtn.classList.toggle('is-on', S.sub);
        els.subBtn.setAttribute('aria-checked', S.sub ? 'true' : 'false');
      }
      $$('[data-om-suboff]', box).forEach(function (e) { var d = Math.max(0, one - sub); e.textContent = '$' + (d % 100 ? (d / 100).toFixed(2) : (d / 100)) + ' off'; });
      $$('[data-om-subcard-price]', box).forEach(function (e) { e.textContent = money(S.sub ? sub : one); });
      $$('[data-om-subcard-strike]', box).forEach(function (e) { e.textContent = money(one); e.hidden = !S.sub || !(one > sub); });
      box.classList.toggle('is-onetime', !S.sub);
      // CTA shows the pack chosen, not the total (10 Pack, else 30 Pack for single-30 and variety).
      var packLabel = (S.flavor === 'v' || S.size === 30) ? '30 Pack' : '10 Pack';
      if (els.addWrap) els.addWrap.hidden = true;
      var avail = available();
      var needBuild = variety && !vComplete();
      var dis = needBuild || !avail;
      if (els.add) { els.add.disabled = dis; els.add.setAttribute('aria-disabled', dis ? 'true' : 'false'); els.add.classList.toggle('is-locked', needBuild); }
      if (needBuild) { var left = (3 - S.f - S.p) * 10; txt(els.addLabel, (S.f + S.p === 0) ? 'Build your 30-pack' : ('Add ' + left + ' more bars')); }
      else txt(els.addLabel, avail ? ('Add to Cart: ' + packLabel) : 'Sold Out');
      box.setAttribute('data-scb-ready', (V.f10 && V.p10) ? 'true' : 'loading');
      document.dispatchEvent(new CustomEvent('scb:change', { detail: { perBox: perBox(), total: total(), sub: S.sub, desc: flavorName() + ' · ' + (boxes() * 10) + ' bars', avail: avail } }));
    }

    function add(extra) {
      var its = items();
      if (!its.length) { toast('Loading prices — try again in a second'); return; }
      cartAdd(its, [els.add].concat(extra || []).filter(Boolean));
    }

    function needsLive() { return !V.f10 || !V.f30 || !V.p10 || !V.p30 || !V.vf10 || !V.vp10; }
    function loadLive() {
      var H = cfg.handles || {}, pending = 4, got = {};
      function done() {
        if (--pending) return;
        if (got.f) { V.f10 = V.f10 || got.f.v10; V.f30 = V.f30 || got.f.v30; }
        if (got.p) { V.p10 = V.p10 || got.p.v10; V.p30 = V.p30 || got.p.v30; }
        if (got.vf) { V.vf10 = V.vf10 || got.vf.v10; }
        if (got.vp) { V.vp10 = V.vp10 || got.vp.v10; }
        render();
      }
      getJSON('/products/' + (H.f || 'fudgebrownie') + '.js', function (r) { if (r) got.f = fromProductJs(r); done(); });
      getJSON('/products/' + (H.p || 'the-creatine-protein-bar-pbcc') + '.js', function (r) { if (r) got.p = fromProductJs(r); done(); });
      getJSON('/products/' + (H.vf || 'soar-bars-fudge-brownie') + '.js', function (r) { if (r) got.vf = fromProductJs(r); done(); });
      getJSON('/products/' + (H.vp || 'soar-bars-pbcc') + '.js', function (r) { if (r) got.vp = fromProductJs(r); done(); });
    }
    if (needsLive()) loadLive();

    return { add: add, el: els.add, render: render, box: box, setFlavor: setFlavor, setSize: setSize, setPack: setPack, toggleSub: toggleSub, setSub: setSub, pickStep: pickStep };
  }

  // One controller per buy box, created on demand. All events are delegated from document,
  // so they keep working if the section is re-rendered (theme editor) or an app re-draws it.
  function buyFor(el) {
    var box = el && el.closest ? el.closest('[data-scb-box]') : null;
    if (!box) return null;
    if (!box.__scbBuy) { try { box.__scbBuy = Buy(box); box.__scbBuy.render(); } catch (e) { if (window.console) console.error('[scb] buy box', e); return null; } }
    return box.__scbBuy;
  }
  var delegated = false;
  function initBuy() {
    var first = null;
    $$('[data-scb-box]').forEach(function (box) { var b = buyFor(box); if (!first) first = b; });
    if (!delegated) {
      delegated = true;
      document.addEventListener('click', function (e) {
        var t = e.target;
        var pa = t.closest && t.closest('[data-om-pick-add]');
        if (pa) { var bpa = buyFor(pa); if (bpa) { e.preventDefault(); bpa.pickStep(pa.getAttribute('data-om-pick-add'), 1); } return; }
        var ps = t.closest && t.closest('[data-om-pick-step]');
        if (ps) { var bps = buyFor(ps); if (bps) { e.preventDefault(); bps.pickStep(ps.getAttribute('data-om-pick-step'), +ps.getAttribute('data-d')); } return; }
        var ms = t.closest && t.closest('[data-scb-mixset]');
        if (ms) { var bm = buyFor(ms); if (bm) { e.preventDefault(); bm.setMix(ms.getAttribute('data-scb-mixset')); } return; }
        var mx = t.closest && t.closest('[data-om-mix]');
        if (mx) { var bx = buyFor(mx); if (bx) { e.preventDefault(); var m = bx.mix(); bx.setMix(m === 1 || m === 2 ? m : 1); } return; }
        var pl = t.closest && t.closest('[data-scb-plan]');
        if (pl) { var bp = buyFor(pl); if (bp) { e.preventDefault(); bp.setSub(pl.getAttribute('data-scb-plan') === 'sub'); } return; }
        var fc = t.closest && t.closest('[data-scb-flavor]');
        if (fc) { var bfc = buyFor(fc); if (bfc && bfc.setFlavor) { e.preventDefault(); bfc.setFlavor(fc.getAttribute('data-scb-flavor')); } return; }
        var sc = t.closest && t.closest('[data-scb-size]');
        if (sc) { var bsc = buyFor(sc); if (bsc && bsc.setSize) { e.preventDefault(); bsc.setSize(sc.getAttribute('data-scb-size')); } return; }
        var pc = t.closest && t.closest('[data-scb-pack]');
        if (pc) { var bpc = buyFor(pc); if (bpc && bpc.setPack) { e.preventDefault(); bpc.setPack(pc.getAttribute('data-scb-pack')); } return; }
        var sub = t.closest && t.closest('[data-scb-sub-toggle]');
        if (sub) { var b = buyFor(sub); if (b) { e.preventDefault(); b.toggleSub(); } return; }
        var addBtn = t.closest && t.closest('[data-scb-add]');
        if (addBtn) { var b2 = buyFor(addBtn); if (b2) { e.preventDefault(); b2.add(); } return; }
        var mt = t.closest && t.closest('[data-scb-mix-toggle]');
        if (mt) { var b3 = buyFor(mt); if (b3) b3.toggleMix(mt); return; }
        var end = t.closest && t.closest('[data-scb-end]');
        if (end) { var b4 = buyFor(end); if (b4) b4.setMix(end.getAttribute('data-scb-end') === 'p' ? 3 : 0); }
      });
      function onRange(e) {
        var r = e.target; if (!r || !r.matches || !r.matches('[data-scb-range]')) return;
        var val = r.value; var b = buyFor(r); if (b) b.setMix(val);
      }
      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        var pl = e.target && e.target.closest && e.target.closest('[data-scb-plan],[data-scb-sub-toggle]');
        if (pl) { e.preventDefault(); pl.click(); }
      });
      document.addEventListener('input', onRange);
      document.addEventListener('change', onRange);
      document.addEventListener('shopify:section:load', function () { initBuy(); try { initOm(); } catch (e) {} });
    }
    return first;
  }

  // ─────────────────────────── Sticky ATC ───────────────────────────
  function initSticky(buy) {
    var bar = $('[data-scb-sticky]');
    if (!bar || !buy) return;
    var btn = $('[data-scb-sticky-add]', bar);
    var desc = $('[data-scb-sticky-desc]', bar);
    var price = $('[data-scb-sticky-price]', bar);
    document.addEventListener('scb:change', function (e) {
      var d = e.detail;
      if (desc) desc.textContent = d.desc + (d.sub ? ' · Subscribe' : '');
      if (price) price.textContent = money(d.perBox) + '/box';
      if (btn) btn.disabled = !d.avail;
    });
    if (btn) btn.addEventListener('click', function () { buy.add([btn]); });
    var footerCta = $('[data-scb-final]');
    var ticking = false;
    function upd() {
      ticking = false;
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var heroOut = buy.el ? buy.el.getBoundingClientRect().bottom < 0 : false;
      var finalIn = false;
      if (footerCta) { var r = footerCta.getBoundingClientRect(); finalIn = r.top < vh && r.bottom > 0; }
      bar.classList.toggle('is-on', heroOut && !finalIn);
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(upd); } }, { passive: true });
    window.addEventListener('resize', upd);
    upd();
  }

  // ─────────────────────────── Final CTA price ───────────────────────────
  function initFinal(buy) {
    $$('[data-scb-final-price]').forEach(function (el) {
      document.addEventListener('scb:change', function (e) { el.textContent = money(e.detail.perBox); });
    });
    $$('[data-scb-final-add]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (buy) buy.add([b]);
        else { var t = $('#scb-buy'); if (t) t.scrollIntoView({ behavior: 'smooth' }); }
      });
    });
  }

  // ─────────────────────────── Science tabs ───────────────────────────
  function initTabs() {
    $$('[data-scb-tabs]').forEach(function (root) {
      var tabs = $$('[data-scb-tab]', root), panels = $$('[data-scb-panel]', root);
      function show(i) {
        tabs.forEach(function (t, j) { t.classList.toggle('is-active', i === j); t.setAttribute('aria-selected', i === j ? 'true' : 'false'); t.tabIndex = i === j ? 0 : -1; });
        panels.forEach(function (p, j) { p.hidden = i !== j; });
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { show(i); });
        t.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); var n = (i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length; show(n); tabs[n].focus(); }
        });
      });
      show(0);
    });
  }

  // ─────────────────────────── UGC rail ───────────────────────────
  function initRails() {
    $$('[data-scb-rail-wrap]').forEach(function (w) {
      var rail = $('[data-scb-rail]', w);
      if (!rail) return;
      $$('[data-scb-rail-prev],[data-scb-rail-next]', w).forEach(function (b) {
        b.addEventListener('click', function () {
          var dir = b.hasAttribute('data-scb-rail-next') ? 1 : -1;
          rail.scrollBy({ left: dir * (rail.clientWidth * 0.8), behavior: 'smooth' });
        });
      });
      var vids = $$('video', rail);
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) {
          es.forEach(function (x) { var v = x.target; if (x.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else v.pause(); });
        }, { threshold: 0.5 });
        vids.forEach(function (v) { io.observe(v); });
      }
      $$('[data-scb-mute]', w).forEach(function (b) {
        b.addEventListener('click', function () {
          var v = b.closest('.scb-vid').querySelector('video'); if (!v) return;
          v.muted = !v.muted; b.setAttribute('aria-pressed', v.muted ? 'false' : 'true');
          $('[data-ic-mute]', b).hidden = !v.muted; $('[data-ic-sound]', b).hidden = v.muted;
        });
      });
    });
  }

  // ─────────────────────────── Reviews more ───────────────────────────
  function initMore() {
    $$('[data-scb-more]').forEach(function (b) {
      var root = b.closest('[data-scb-reviews]');
      b.addEventListener('click', function () {
        var hidden = $$('.scb-rtile[hidden], .scb-rv[hidden]', root);
        hidden.slice(0, 5).forEach(function (t) { t.hidden = false; });
        if ($$('.scb-rtile[hidden], .scb-rv[hidden]', root).length === 0) b.remove();
      });
    });
  }

  // ─────────────────────────── Reveal ───────────────────────────
  function initReveal() {
    var els = $$('.scb-reveal');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  // ─────────────────────────── Facts modal / More FAQs ───────────────────────────
  function initFacts() {
    var dlg = $('[data-scb-facts-dialog]');
    if (!dlg) return;
    $$('a[href="#scb-facts"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        if (typeof dlg.showModal !== 'function') return;
        e.preventDefault(); dlg.showModal();
      });
    });
    $$('[data-scb-facts-close]', dlg).forEach(function (b) { b.addEventListener('click', function () { dlg.close(); }); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
  }
  function initVideos() {
    var btns = $$('[data-scb-video]');
    if (!btns.length) return;
    var dlg = document.createElement('dialog');
    dlg.className = 'scb-dialog scb-dialog--video';
    dlg.innerHTML = '<button type="button" class="scb-dialog__x" aria-label="Close">\u2715</button><video playsinline controls></video>';
    (document.querySelector('.scb') || document.body).appendChild(dlg);
    var v = dlg.querySelector('video');
    function close() { v.pause(); dlg.close(); }
    dlg.querySelector('button').addEventListener('click', close);
    dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
    dlg.addEventListener('close', function () { v.pause(); });
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        v.src = b.getAttribute('data-scb-video');
        if (b.getAttribute('data-poster')) v.poster = b.getAttribute('data-poster');
        if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
        var pr = v.play(); if (pr && pr.catch) pr.catch(function () {});
      });
    });
  }
  function initTestimonials() {
    $$('[data-scb-testi]').forEach(function (root) {
      var rail = $('[data-scb-tr]', root), bar = $('[data-scb-tbar]', root), p = $('[data-scb-tp]', root), n = $('[data-scb-tn]', root);
      if (!rail) return;
      function upd() {
        var max = rail.scrollWidth - rail.clientWidth, frac = rail.clientWidth / rail.scrollWidth;
        if (bar) { bar.style.setProperty('--p', (frac * 100) + '%'); bar.style.left = (max > 0 ? rail.scrollLeft / max * (1 - frac) * 100 : 0) + '%'; }
        if (p) p.disabled = rail.scrollLeft <= 2; if (n) n.disabled = rail.scrollLeft >= max - 2;
      }
      function go(d) { rail.scrollBy({ left: d * rail.clientWidth, behavior: 'smooth' }); }
      if (p) p.addEventListener('click', function () { go(-1); });
      if (n) n.addEventListener('click', function () { go(1); });
      rail.addEventListener('scroll', upd, { passive: true }); window.addEventListener('resize', upd); upd();
    });
  }
  function initQuick() {
    $$('[data-scb-quick]').forEach(function (f) {
      var q = $('input[name=quantity]', f);
      $$('[data-scb-qm],[data-scb-qp]', f).forEach(function (b) {
        b.addEventListener('click', function () { var v = (+q.value || 1) + (b.hasAttribute('data-scb-qp') ? 1 : -1); q.value = Math.max(1, v); });
      });
      f.addEventListener('submit', function (e) {
        e.preventDefault();
        cartAdd([{ id: +$('input[name=id]', f).value, quantity: Math.max(1, +q.value || 1) }], [$('button[type=submit]', f)]);
      });
    });
  }
  function initTrust() {
    $$('[data-scb-trust]').forEach(function (root) {
      var rail = $('[data-scb-trust-rail]', root), p = $('[data-scb-trust-prev]', root), n = $('[data-scb-trust-next]', root);
      if (!rail) return;
      function upd() { var max = rail.scrollWidth - rail.clientWidth; if (p) p.disabled = rail.scrollLeft <= 2; if (n) n.disabled = rail.scrollLeft >= max - 2; }
      function card() { var c = rail.querySelector('.scb-tvid'); return c ? c.getBoundingClientRect().width + 22 : 300; }
      if (p) p.addEventListener('click', function () { rail.scrollBy({ left: -card(), behavior: 'smooth' }); });
      if (n) n.addEventListener('click', function () { rail.scrollBy({ left: card(), behavior: 'smooth' }); });
      rail.addEventListener('scroll', upd, { passive: true }); window.addEventListener('resize', upd); upd();
      var cards = $$('[data-scb-tvid]', root);
      function stopAll(except) { cards.forEach(function (c) { if (c === except) return; var v = $('video', c); if (v && !v.paused) v.pause(); c.classList.remove('is-playing'); }); }
      cards.forEach(function (c) {
        var v = $('video', c);
        c.addEventListener('click', function () {
          if (!v) return;
          if (v.paused) { stopAll(c); v.muted = false; v.controls = true; var pr = v.play(); if (pr && pr.catch) pr.catch(function () { v.muted = true; v.play(); }); c.classList.add('is-playing'); }
          else if (!v.controls) { v.pause(); c.classList.remove('is-playing'); }
        });
        if (v) v.addEventListener('pause', function () { c.classList.remove('is-playing'); });
      });
    });
  }
  function initFaqMore() {
    $$('[data-scb-faq-more]').forEach(function (b) {
      b.addEventListener('click', function () {
        $$('[data-scb-faq-extra]', b.closest('section')).forEach(function (d) { d.hidden = false; });
        b.remove();
      });
    });
  }


  // ─────────────────────────── Omni UI ───────────────────────────
  function railDots(rail, dots) {
    if (!rail || !dots) return;
    var kids = Array.prototype.slice.call(rail.children);
    dots.innerHTML = kids.map(function (_, i) { return '<span' + (i === 0 ? ' class="is-on"' : '') + '></span>'; }).join('');
    function upd() {
      var mid = rail.scrollLeft + rail.clientWidth / 2, idx = 0, best = 1e9;
      kids.forEach(function (k, i) { var c = k.offsetLeft - rail.offsetLeft + k.offsetWidth / 2; var d = Math.abs(c - mid); if (d < best) { best = d; idx = i; } });
      $$('span', dots).forEach(function (d, i) { d.classList.toggle('is-on', i === idx); });
    }
    rail.addEventListener('scroll', function () { window.requestAnimationFrame(upd); }, { passive: true });
  }
  function initOm() {
    $$('[data-om-rail]').forEach(function (rail) {
      if (rail.__om) return; rail.__om = true;
      var dots = rail.parentNode.querySelector('[data-om-dots]');
      railDots(rail, dots);
      // start on the 2nd card like Omni when there are 3+
      if (rail.hasAttribute('data-om-start-mid') && rail.children.length > 2 && window.matchMedia('(max-width: 989px)').matches) {
        var k = rail.children[1]; rail.scrollLeft = k.offsetLeft - rail.offsetLeft - (rail.clientWidth - k.offsetWidth) / 2;
      }
    });
    $$('[data-om-gal]').forEach(function (g) {
      if (g.__om) return; g.__om = true;
      var track = $('[data-om-gal-track]', g), thumbs = $$('[data-om-gal-thumb]', g);
      if (!track) return;
      function go(i) { var n = track.children.length; i = (i + n) % n; track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }); }
      function cur() { return Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); }
      thumbs.forEach(function (b) { b.addEventListener('click', function () { go(+b.getAttribute('data-om-gal-thumb')); }); });
      var p = $('[data-om-gal-prev]', g), n = $('[data-om-gal-next]', g);
      if (p) p.addEventListener('click', function () { go(cur() - 1); });
      if (n) n.addEventListener('click', function () { go(cur() + 1); });
      track.addEventListener('scroll', function () { var i = cur(); thumbs.forEach(function (b, k) { b.classList.toggle('is-on', k === i); }); }, { passive: true });
    });
    $$('[data-om-tabs]').forEach(function (root) {
      if (root.__om) return; root.__om = true;
      var btns = $$('[data-om-tab]', root), panes = $$('[data-om-pane]', root);
      btns.forEach(function (b) {
        b.addEventListener('click', function () {
          var k = b.getAttribute('data-om-tab');
          btns.forEach(function (x) { var on = x === b; x.classList.toggle('is-on', on); x.setAttribute('aria-selected', on ? 'true' : 'false'); });
          panes.forEach(function (pn) { pn.hidden = pn.getAttribute('data-om-pane') !== k; });
        });
      });
    });

    $$('[data-om-ins]').forEach(function (root) {
      if (root.__om) return; root.__om = true;
      var cards = $$('[data-om-ins-card]', root), n = cards.length, cur = 0;
      function show(i) {
        cur = (i + n) % n;
        cards.forEach(function (c, k) { c.hidden = k !== cur; });
        $$('[data-om-ins-go]', root).forEach(function (b) { var on = +b.getAttribute('data-om-ins-go') === cur; b.classList.toggle('is-on', on); if (b.hasAttribute('aria-selected')) b.setAttribute('aria-selected', on ? 'true' : 'false'); if (b.hasAttribute('aria-expanded')) b.setAttribute('aria-expanded', on ? 'true' : 'false'); });
      }
      root.addEventListener('click', function (e) {
        var g = e.target.closest('[data-om-ins-go]'); if (g) { show(+g.getAttribute('data-om-ins-go')); return; }
        var st = e.target.closest('[data-om-ins-step]'); if (st) show(cur + (+st.getAttribute('data-om-ins-step')));
      });
    });
    $$('[data-om-faq]').forEach(function (root) {
      if (root.__om) return; root.__om = true;
      var items = $$('details', root);
      items.forEach(function (d) { d.addEventListener('toggle', function () { if (d.open) items.forEach(function (o) { if (o !== d) o.open = false; }); }); });
    });
    $$('[data-om-more]').forEach(function (b) {
      if (b.__om) return; b.__om = true;
      b.addEventListener('click', function () {
        var list = b.parentNode.querySelector('[data-om-morelist]');
        var hidden = list ? $$('[hidden]', list) : [];
        hidden.slice(0, 5).forEach(function (h) { h.hidden = false; });
        if (!list || !$$('[hidden]', list).length) b.remove();
      });
    });
    $$('[data-om-vids]').forEach(function (root) {
      if (root.__om) return; root.__om = true;
      var cards = $$('[data-om-vid]', root);
      function stopAll(ex) { cards.forEach(function (c) { if (c === ex) return; var v = $('video', c); if (v && !v.paused) v.pause(); c.classList.remove('is-playing'); }); }
      cards.forEach(function (c) {
        var v = $('video', c);
        c.addEventListener('click', function () {
          if (!v) return;
          if (v.paused) { stopAll(c); v.muted = false; v.controls = true; var pr = v.play(); if (pr && pr.catch) pr.catch(function () { v.muted = true; v.play(); }); c.classList.add('is-playing'); }
        });
        if (v) v.addEventListener('pause', function () { c.classList.remove('is-playing'); });
      });
    });
  }

  function init() {
    var buy = null;
    try { buy = initBuy(); } catch (e) { if (window.console) console.error('[scb]', e); }
    [function () { initSticky(buy); }, function () { initFinal(buy); }, initTabs, initRails, initMore, initReveal, initFacts, initFaqMore, initVideos, initTestimonials, initQuick, initTrust, initOm]
      .forEach(function (fn) { try { fn(); } catch (e) { if (window.console) console.error('[scb]', e); } });
    if (buy) { try { buy.render(); } catch (e) {} }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
